// @flow
import React from 'react';
import classnames from 'classnames';

import ratioUtils from 'Components/utils/ratios/ratios.utils';

import { ImagePlaceholder } from 'Components/frameworks/image-placeholder/ImagePlaceholder.jsx';

import { getVideoUrl, isVideoUrl } from './Video.utils';

export type VideoProps = {
  className?: string,
  iFrameClassName?: string,
  ratioKey?: string,
  url: string,
};

export function Video(props: VideoProps) {
  const { className, iFrameClassName, ratioKey = ratioUtils.L, url } = props;

  if (!isVideoUrl(url)) return null;

  return (
    <ImagePlaceholder aspectRatio={100 * ratioUtils.values[ratioKey]} className={className}>
      <div className="leading-none flex h-full items-center justify-center overflow-hidden">
        <iframe
          title="Video iframe"
          className={classnames(iFrameClassName, 'border-0 fadeIn format-16/9 max-h-full')}
          src={getVideoUrl(url)}
        />
      </div>
    </ImagePlaceholder>
  );
}
